// extracted by mini-css-extract-plugin
export default {"dateTime":"Body_dateTime__jIjKn","backLink":"Body_backLink__2AgiI","checkbox":"Body_checkbox__mRvaC"};